module.exports = __webpack_public_path__ + "e6702a8d3629e7a06d2b57796dfaf8f7.svg";